import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Pipe({
    name: 'getStepForm'
})
export class GetStepFormPipe implements PipeTransform {
    transform(stepName: string, workflowFormGroup: FormGroup): FormGroup {
        if (!workflowFormGroup || !stepName) return new FormGroup({});

        return workflowFormGroup.controls['steps'].get(`step-${stepName}`) as FormGroup;
    }
}
